import React from 'react';
import { Link } from 'react-router-dom';

import ConversationsListItem from './legacy_conversations_list_item';

import styles from './legacy_conversation_room.module.css';

export default function ConversationList({ conversations, pathToMatch = '', selectedConversation, isLoading = false }) {
  return (
    <>
      {conversations && (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
          <div className={styles.convo_list_header}>
            <h5>My Conversations</h5>
          </div>
          <div
            className={`container ${styles.convo_list} ${isLoading ? styles.convo_list_loading : ''}`}
            aria-busy={isLoading ? 'true' : 'false'}
          >
            <div className='row'>
              <div className='col de-pad'>
                {conversations && conversations.length === 0 && (
                  <p style={{ padding: '15px' }}>This is where you'll find a list of conversations you're having!</p>
                )}
                {conversations && (
                  <>
                    {conversations.map((conversation, i) => (
                      <div key={i}>
                        <Link to={`${pathToMatch}${conversation.uuid}`}>
                          <ConversationsListItem
                            conversation={conversation}
                            selectedConversation={selectedConversation}
                          />
                        </Link>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
            {isLoading && (
              <div className={styles.convo_list_loading_overlay} role='status' aria-live='polite'>
                <span className={styles.convo_list_loading_spinner} aria-hidden='true' />
                <span>Loading conversations...</span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
